var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-text"},[(_vm.icon === 'RegisterIcon')?_c('RegisterIcon',{staticClass:"svg-icon svg-icon-register"}):_vm._e(),(_vm.icon === 'WhiteAnchorIcon')?_c('WhiteAnchorIcon',{staticClass:"svg-icon svg-icon-white-anchor"}):_vm._e(),_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }